/**
 * How long a new staff invitation stays redeemable, as the operator last set
 * it on the Staff page. Stored per browser: it is a working preference, not a
 * platform setting, and the invite form reads the same value the page shows.
 */
export const TTL_DEFAULT = 15;
export const TTL_MIN = 1;
export const TTL_MAX = 10080;

const TTL_STORAGE_KEY = 'optum.invite.ttlMinutes';

export function readStoredTtl(): number {
  if (typeof window === 'undefined') return TTL_DEFAULT;
  try {
    const raw = window.localStorage.getItem(TTL_STORAGE_KEY);
    const n = raw ? Number(raw) : NaN;
    if (!Number.isFinite(n) || n < TTL_MIN || n > TTL_MAX) return TTL_DEFAULT;
    return Math.floor(n);
  } catch {
    return TTL_DEFAULT;
  }
}

export function writeStoredTtl(value: number): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(TTL_STORAGE_KEY, String(value));
  } catch {
    // A blocked store keeps the value for this page only; nothing else needs it.
  }
}

export function clampTtl(value: number): number {
  return Math.max(TTL_MIN, Math.min(TTL_MAX, Math.floor(value || TTL_DEFAULT)));
}
